<template lang="pug">
	.creative-script-resource.flex-col.space-large
		Loader(v-if="isLoading", :fullscreen="true")
		.flex-row.space
			DxButton(@click="addNewResource", :text="$tCaption('New resource')", icon="plus", :disabled="!!isCreatingResource")
		.resource.flex-col.space-large(v-for="(resource, index) in resources")
			Loader(v-if="resource.__isLoading", text="", :fullscreen="true")
			.flex-row.justify.align-center
				.flex-row.space.align-center
					.flex-col.field
						.font-small.upper.grey {{$tCaption('Resource type')}}
						DxSelectBox(:value.sync="resource.ResourceType", :dataSource="sourceTypes", displayExpr="name", valueExpr="id", @value-changed="createUpdateScriptResource(resource)")
					.flex-col.field
						.font-small.upper.grey {{$tCaption('Width')}}
						DxNumberBox(:value.sync="resource.Width", :width="90", @value-changed="createUpdateScriptResource(resource)")
					.flex-col.field
						.font-small.upper.grey {{$tCaption('Height')}}
						DxNumberBox(:value.sync="resource.Height", :width="90", @value-changed="createUpdateScriptResource(resource)")
				DxButton(v-if="resource.Oid", stylingMode="text", icon="close", @click="deleteScriptResource(resource, index)")
			.flex-row.space
				.flex-col.field.flex-1
					.font-small.upper.grey {{$tCaption('Clickout link')}}
					DxTextBox(:value.sync="resource.ClickoutLink", @value-changed="createUpdateScriptResource(resource)")
				.flex-col.field.flex-1
					.font-small.upper.grey {{$tCaption('Impression pixel')}}
					DxTextBox(:value.sync="resource.ImpressionPixel", @value-changed="createUpdateScriptResource(resource)")
			.flex-col.field
				.font-small.upper.grey {{$tCaption('Script')}}
				DxTextArea(:value.sync="resource.Script", :height="100", @value-changed="createUpdateScriptResource(resource)")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import { CREATIVE_SCRIPT_SOURCE_TYPES } from 'app-core/constants';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxTextArea from 'devextreme-vue/text-area';

	export default {
		translationCategory: 'creative.CreativescriptResource',
		name: 'creative-script-resource',
		components: {
			Loader, DxButton, DxTextBox, DxNumberBox, DxSelectBox, DxTextArea
		},
		props: ['creativeId'],
		data() {
			return {
				resources: [],
				isLoading: false,
				sourceTypes: CREATIVE_SCRIPT_SOURCE_TYPES.toLocale('name', this),
				isCreatingResource: false
			};
		},
		mounted() {
			if (__DEBUG__)
				window.creativeScriptResource= this;
			this.loadscriptResources();
		},
		methods: {
			deleteScriptResource(resource, index) {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete the current script resource?'),
					handler: () => {
						this.resources.splice(index, 1);
						this.$Data.getExternalApi('ScriptResource/DeleteScriptResource', `id=${resource?.Oid}`);
					}
				});
			},
			addNewResource() {
				const source = {
					Oid: null,
					Script: null,
					Width: null,
					Height: null,
					ClickoutLink: null,
					ImpressionPixel: null,
					ResourceType: 0,
					Creative: {
						Oid: this.creativeId
					}
				};
				this.isCreatingResource++;
				this.createUpdateScriptResource(source).finally(() => this.isCreatingResource--);
				this.resources.push(source);
			},
			loadscriptResources() {
				this.isLoading++;
				this.$Data.getExternalApi('ScriptResource/GetAllScriptResources', `creativeId=${this.creativeId}`, 999)
					.then(r => this.resources = r?.Results || [])
					.finally(() => this.isLoading--);
			},
			createUpdateScriptResource(resource) {
				this.$set(resource, '__isLoading', (resource?.__isLoading || 0) + 1);	
				if (resource.__isLoading > 1) return;
				return this.$Data.postExternalApi('ScriptResource/CreateUpdateScriptResource', resource)
					.then(r => {
						if (!resource.Oid) {
							resource.Oid = r.Data.Oid;
						}
					})
					.finally(() => {
						resource.__isLoading--;
						if (resource.__isLoading > 0) {
							resource.__isLoading = 0;
							this.createUpdateScriptResource(resource);
						}
					})
			}
		}
	};
</script>
<style lang='scss'>
	.creative-script-resource {
		.resource {
			position: relative;
			padding: 20px;
			background: #fff;
			border-radius: 4px;
			box-shadow: 0px 1px 4px rgb(0,0,0,.1);
		}
	}
</style>
